'use client';

import { useCallback, useEffect, useState } from 'react';

import type { Navigation } from '@/types/navigation';

let cached: Navigation[] | null = null;
let pending: Promise<Navigation[] | null> | null = null;

const loadMegaMenu = () => {
  pending ??= fetch('/api/navigation')
    .then((res) => (res.ok ? (res.json() as Promise<Navigation[]>) : null))
    .catch(() => null)
    .then((tree) => {
      cached = tree;
      // Hata olduysa bir sonraki hover'da tekrar denensin.
      if (!tree) pending = null;
      return tree;
    });
  return pending;
};

/** Mega menünün göründüğü kırılım (Tailwind `lg`). */
const DESKTOP_QUERY = '(min-width: 1024px)';

/**
 * Mega menü ağacını ilk HTML yerine istemcide çeker: masaüstünde tarayıcı
 * boşa çıkınca önceden, ya da kullanıcı menüye yaklaşınca (`prefetch`).
 * Mobilde menü görünmediği için hiç istenmez.
 */
export const useMegaMenu = () => {
  const [tree, setTree] = useState<Navigation[] | null>(cached);

  const prefetch = useCallback(() => {
    if (cached) return;
    loadMegaMenu().then(setTree);
  }, []);

  useEffect(() => {
    if (cached || !window.matchMedia(DESKTOP_QUERY).matches) return;

    // requestIdleCallback Safari'de yok; orada kısa bir gecikmeyle yükle.
    if ('requestIdleCallback' in window) {
      const id = window.requestIdleCallback(prefetch, { timeout: 4000 });
      return () => window.cancelIdleCallback(id);
    }
    const id = setTimeout(prefetch, 2000);
    return () => clearTimeout(id);
  }, [prefetch]);

  return { tree, prefetch };
};
